import { render, staticRenderFns } from "./PositionsDistributionChart.vue?vue&type=template&id=5c161cdc&scoped=true&"
import script from "./PositionsDistributionChart.vue?vue&type=script&lang=js&"
export * from "./PositionsDistributionChart.vue?vue&type=script&lang=js&"
import style0 from "./PositionsDistributionChart.vue?vue&type=style&index=0&id=5c161cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c161cdc",
  null
  
)

/* custom blocks */
import block0 from "./PositionsDistributionChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports